import { useMutation } from "react-query";
import { UploadAnexosContaForm } from "../typings";
import http from "infra/http";

function useUploadAnexosConta() {
  return useMutation((data: UploadAnexosContaForm) => {
    return http.post(`/v1/conta/${data.id}/anexos/${data.tipoAnexoId}`, {
      anexos: data.anexos,
      arquivosExcluidos: data.arquivosExcluidos,
    });
  });
}

export default useUploadAnexosConta;
